import { cn } from "~/lib/utils"
import * as React from "react"
import * as SeparatorPrimitive from "@radix-ui/react-separator"
import { cva, type VariantProps } from "class-variance-authority"

const separatorVariants = cva("h-separator", {
  variants: {
    orientation: {
      horizontal: "h-separator--horizontal",
      vertical: "h-separator--vertical",
    },
    full: {
      true: "h-separator--full",
    },
    variant: {
      default: "",
      light: "h-separator--light",
      dark: "h-separator--dark",
    },
  },
})

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> &
    VariantProps<typeof separatorVariants>
>(
  (
    {
      className,
      orientation = "horizontal",
      decorative = true,
      full,
      variant,
      ...props
    },
    ref,
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        separatorVariants({ orientation, full, variant }),
        className,
      )}
      asChild={true}
      {...props}
    >
      <hr />
    </SeparatorPrimitive.Root>
  ),
)
Separator.displayName = SeparatorPrimitive.Root.displayName


// Word variant
//
type SeparatorWithWordProps = {
  word?: string
  variant?: VariantProps<typeof separatorVariants>["variant"]
  full?: boolean
  className?: string
}

const SeparatorWithWord = React.forwardRef<
  HTMLDivElement,
  SeparatorWithWordProps
>(({ word = "or", variant, full, className }, ref) => {
  return (
    <div
      ref={ref}
      className={cn("h-separator-with-word", className)}
    >
      <Separator variant={variant} full={full} />
      <span className="text-2xs-medium h-separator-with-word__word">{word}</span>
      <Separator variant={variant} full={full} />
    </div>
  )
})
SeparatorWithWord.displayName = "SeparatorWithWord"

export { Separator, SeparatorWithWord }
